import { orchestrator } from './orchestrator';
import { analysisHandler } from './domains/analysis/analysis.handler';
import { exportHandler } from './domains/export/export.handler';
import { importHandler } from './domains/import/import.handler';
import { sapImportHandler } from './domains/sap-import/sap-import.handler';

export function setupWebSocket(): void {
  orchestrator.setup({
    'analysis': analysisHandler,
    'export': exportHandler,
    'materials-demands-export': exportHandler,
    'po-components-export': exportHandler,
    'stock-export': exportHandler,
    'bom-imports': importHandler,
    'stock-and-po-imports': importHandler,
    'sap-imports': sapImportHandler,
  });
}
